import { render, staticRenderFns } from "./OldApp.vue?vue&type=template&id=5299ecfa&scoped=true&"
import script from "./OldApp.vue?vue&type=script&lang=ts&"
export * from "./OldApp.vue?vue&type=script&lang=ts&"
import style0 from "./OldApp.vue?vue&type=style&index=0&id=5299ecfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5299ecfa",
  null
  
)

export default component.exports